export default "__VITE_ASSET__Du$EB_rn__"